import { config } from "../Constants";

const URL = config.url;

export const fetchPaginatedStocks = async ({
    page = 0,
    pageSize = 20,
    sortField = 'name',
    sortDirection = 'asc',
    filters = {}
}) => {
    const params = new URLSearchParams({
        page: page.toString(),
        size: pageSize.toString(),
        sort: `${sortField},${sortDirection}`
    });

    for (const [key, value] of Object.entries(filters)) {
        if (value === undefined || value === null || value === '') {
            continue;
        }

        if (Array.isArray(value)) {
            value
                .filter((entry) => entry !== undefined && entry !== null && entry !== '')
                .forEach((entry) => params.append(key, entry));
            continue;
        }

        // Handle Date objects
        if (value instanceof Date && !isNaN(value.getTime())) {
            const year = value.getFullYear();
            const month = String(value.getMonth() + 1).padStart(2, '0');
            const day = String(value.getDate()).padStart(2, '0');
            params.append(key, `${year}-${month}-${day}`);
            continue;
        }

        // Handle ISO date strings (fallback)
        if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(value)) {
            const date = new Date(value);
            if (!isNaN(date.getTime())) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                params.append(key, `${year}-${month}-${day}`);
            }
            continue;
        }

        params.append(key, value);
    }

    const response = await fetch(`${URL}/api/v1/stocks?${params}`);
    if (!response.ok) {
        throw new Error('Failed to fetch stocks');
    }
    
    const data = await response.json();
    return data.data;
};

const appendFilterParams = (params, filters) => {
    for (const [key, value] of Object.entries(filters || {})) {
        if (value === undefined || value === null || value === '') {
            continue;
        }

        if (Array.isArray(value)) {
            value
                .filter((entry) => entry !== undefined && entry !== null && entry !== '')
                .forEach((entry) => params.append(key, entry));
            continue;
        }

        if (value instanceof Date && !isNaN(value.getTime())) {
            const year = value.getFullYear();
            const month = String(value.getMonth() + 1).padStart(2, '0');
            const day = String(value.getDate()).padStart(2, '0');
            params.append(key, `${year}-${month}-${day}`);
            continue;
        }

        if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(value)) {
            const date = new Date(value);
            if (!isNaN(date.getTime())) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                params.append(key, `${year}-${month}-${day}`);
            }
            continue;
        }

        params.append(key, value);
    }
};

export const fetchStockSuggestions = ({ query, limit = 6, filters = {} }) => {
    if (!query || query.length < 2) {
        return [];
    }

    const params = new URLSearchParams({
        page: "0",
        size: String(limit),
        sort: "name,asc",
        searchTerm: query
    });
    appendFilterParams(params, filters);

    return fetch(`${URL}/api/v1/stocks?${params}`).then(async (response) => {
        if (!response.ok) {
            throw new Error("Failed to fetch stock suggestions");
        }

        const data = await response.json();
        const content = data?.data?.content || [];

        return content.map((stock) => ({
            sku: stock.sku,
            name: stock.name,
            manufacturer: stock.manufacturer,
            thumbnailImage: stock.thumbnailImage
        }));
    });
};
